"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutType;
(function (ShortcutType) {
    ShortcutType["rootOptions"] = "rootOptions";
    ShortcutType["directResponse"] = "directResponse";
})(ShortcutType = exports.ShortcutType || (exports.ShortcutType = {}));
//# sourceMappingURL=ShortcutType.js.map